import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeliveryForDate } from 'src/app/api/contracts/order';
import { GetDeliveryForDateStatusPipe } from 'src/app/pipes/get-delivery-for-date-status.pipe';
import { DeliveryForDateStatus } from 'src/app/types/delivery-for-date';

@Component({
  selector: 'app-delivery-for-date',
  templateUrl: './delivery-for-date.component.html',
  styleUrls: ['./delivery-for-date.component.scss'],
  providers: [GetDeliveryForDateStatusPipe]
})
export class DeliveryForDateComponent implements OnInit {
  public readonly deliveryStatuses = DeliveryForDateStatus;

  @Input() items: DeliveryForDate[] | null = null;

  @Output() confirmationProcessRequested = new EventEmitter<number>();

  constructor(
    private readonly dateForDeliveryStatusPipe: GetDeliveryForDateStatusPipe
  ) {}

  ngOnInit() {
    return;
  }

  onItemClick(item: DeliveryForDate): void {
    const isItemDelivered =
      this.dateForDeliveryStatusPipe.transform(item) ===
      this.deliveryStatuses.DELIVERED;
    if (isItemDelivered) {
      this.confirmationProcessRequested.next(item.barcode);
    }
  }
}
